import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    container: String
  }

  connect() {
    if (this.dialog && !this.dialog.open) {
      this.dialog.showModal()
    }
  }

  close(event) {
    event?.preventDefault()

    this.dialog?.close()

    if (this.container.tagName === "TURBO-FRAME") {
      this.container.replaceChildren()
    } else {
      this.container.remove()
    }
  }

  get container() {
    if (this.hasContainerValue) {
      return document.getElementById(this.containerValue) || this.element
    }

    return this.element.closest("turbo-frame") || this.element
  }

  get dialog() {
    if (this.element instanceof HTMLDialogElement) {
      return this.element
    }

    return this.element.querySelector("dialog")
  }
}
